import { FormControlProps as BaseFormControlProps, Box, FormControl, forwardRef, rem } from '@bonusly/design-system';

interface FormControlProps extends BaseFormControlProps {
	highlighted?: boolean;
}

export const FormFieldset = forwardRef<FormControlProps, 'div'>(({ highlighted, children, ...rest }: FormControlProps, ref) => {
	const component = (
		<FormControl as="fieldset" gap={1} maxW={rem(480)} ref={ref} {...rest}>
			{children}
		</FormControl>
	);

	if (highlighted) {
		return (
			<Box mx={-4} p={4} borderRadius="lg" backgroundColor="yellow.25">
				{component}
			</Box>
		);
	}

	return component;
});

FormFieldset.displayName = 'FormFieldset';
